import React from "react";

import JobDetail from "../../components/JobDetail/JobDetail.jsx";

export default () => <JobDetail />;
